export default __webpack_public_path__ + "static/media/digita-logo-hybriditv.16ab16a0.svg";